import React, { useState, useEffect } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { auth as authModule } from 'redux/modules'
import PropTypes from 'prop-types'
import axios from 'axios'

const Logout = ({ handleLogout, auth, club }) => {
  const [redirectTo, setRedirectTo] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  // Clear local storage
  localStorage.clear()

  useEffect(() => {
    const { locale } = auth
    const defaultLoginUrl = locale === 'en' ? '/login' : `/${locale}/login`
    const clubUuid = club?.uuid

    handleLogout()

    if (!clubUuid) {
      setRedirectTo(defaultLoginUrl)

      return
    }

    setIsLoading(true)
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/clubs/${clubUuid}/public?include=organization.ssoProviders`
      )
      .then((response) => {
        const clubData = response.data.data
        const ssoProviders =
          clubData?.relationships?.organization?.relationships?.sso_providers

        if (Array.isArray(ssoProviders) && ssoProviders.length > 0) {
          if (ssoProviders.some((p) => p.slug === 'cfg')) {
            setRedirectTo('/cfg')
          } else if (ssoProviders.some((p) => p.slug === 'bmg')) {
            setRedirectTo('/bmg')
          } else if (ssoProviders.some((p) => p.slug === 'bvb-nlz')) {
            setRedirectTo('/bvb-nlz')
          } else {
            setRedirectTo(defaultLoginUrl)
          }
        } else {
          setRedirectTo(defaultLoginUrl)
        }
      })
      .catch(() => {
        setRedirectTo(defaultLoginUrl)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return null
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }

  return null
}

Logout.propTypes = {
  handleLogout: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
  club: PropTypes.shape({
    uuid: PropTypes.string,
  }),
}

Logout.defaultProps = {
  club: null,
}

export default compose(
  withRouter,
  connect(
    ({ auth, clubs }) => ({
      auth,
      club: clubs.current,
    }),
    {
      handleLogout: authModule.logout,
    }
  )
)(Logout)
